import api from '../token';

export const ListBanner = async () => {
  try {
    const response = await api.post('/getBanner');
    return response.data;
  } catch (error) {
   
    return [];
  }
};

